import React from 'react';
import NextLink from 'next/link';

interface Image {
  fields: {
    file: {
      url: string;
    };
  };
}
export interface MiniCard {
  image?: Image;
  url: string;
}

export interface Props {
  miniCard: MiniCard;
  className?: string;
  index?: number;
  children?: React.ReactNode;
}

const MiniCard: React.FC<Props> = ({
  miniCard,
  className = 'bg-100 flex size-160 items-center space-x-4 bg-cover p-20 transition-shadow',
  index = 0,
}) => {
  return (
    <div>
      <NextLink href={miniCard.url} data-testid={`eco-mini-card-${index}`}>
        <img className={className} src={miniCard.image?.fields?.file?.url} />
      </NextLink>
    </div>
  );
};

export default MiniCard;
